import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../contexts/LanguageContext';

const MetricCard = ({ 
  title, 
  value, 
  change, 
  changeType = 'positive', 
  icon, 
  trend = [],
  loading = false 
}) => {
  const { t } = useLanguage();
  const changeColor = changeType === 'positive' ?'text-success' 
    : changeType === 'negative' ?'text-error' :'text-muted-foreground';

  const changeIcon = changeType === 'positive' ?'TrendingUp' 
    : changeType === 'negative' ?'TrendingDown' :'Minus';

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 border border-border shadow-warm hover:shadow-warm-md transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="caption text-muted-foreground mb-1">{title}</p>
          {loading ? (
            <div className="h-8 w-24 bg-muted animate-pulse rounded" />
          ) : (
            <h3 className="text-2xl md:text-3xl font-semibold text-foreground data-text">
              {value}
            </h3>
          )}
        </div>
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name={icon} size={20} className="text-primary" />
        </div>
      </div>
      {change !== undefined && (
        <div className="flex items-center gap-2">
          <div className={`flex items-center gap-1 ${changeColor}`}>
            <Icon name={changeIcon} size={16} />
            <span className="caption font-medium">{change}</span>
          </div>
          <span className="caption text-muted-foreground">{t('superAdmin.vsLastMonth')}</span>
        </div>
      )}
      {trend?.length > 0 && (
        <div className="mt-3 flex items-end gap-1 h-8">
          {trend?.map((value, index) => (
            <div
              key={index}
              className="flex-1 bg-primary/20 rounded-sm transition-all hover:bg-primary/30"
              style={{ height: `${(value / Math.max(...trend)) * 100}%` }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MetricCard;